import { render } from "./FullStats.vue?vue&type=template&id=3b25e82e&scoped=true"
import script from "./FullStats.vue?vue&type=script&lang=js"
export * from "./FullStats.vue?vue&type=script&lang=js"

import "./FullStats.vue?vue&type=style&index=0&id=3b25e82e&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b25e82e"]])

export default __exports__